function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.564424 15.809L0.564309 15.809V15.8142V16.8878C0.564309 18.0308 1.53216 18.9633 2.70444 18.9633H13.0079C14.1805 18.9633 15.1195 18.0543 15.1195 16.9116V16.1959C15.1195 12.7257 11.8319 9.94541 7.85616 9.94541C3.85562 9.94541 0.71032 12.4827 0.564424 15.809ZM7.91229 10.9235H7.91308C11.3365 10.9235 14.084 13.3193 14.084 16.2436V16.9116C14.084 17.5429 13.5915 18.0329 13.0363 18.0329H2.7329C2.15115 18.0329 1.68522 17.5448 1.68522 16.9116V16.0051C1.68522 13.157 4.37008 10.9 7.91229 10.9235Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.238569
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.64341 4.53704C3.64341 6.84547 5.53379 8.73585 7.84222 8.73585C10.1506 8.73585 12.041 6.84547 12.041 4.53704C12.041 2.22862 10.1506 0.338235 7.84222 0.338235C5.53379 0.338235 3.64341 2.22862 3.64341 4.53704ZM4.59769 4.53704C4.59769 2.74209 6.04726 1.29251 7.84222 1.29251C9.63717 1.29251 11.0868 2.74209 11.0868 4.53704C11.0868 6.332 9.63717 7.78158 7.84222 7.78158C6.04726 7.78158 4.59769 6.332 4.59769 4.53704Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.238569
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.4f258b80.svg";
export { ForwardRef as ReactComponent };